module.exports = __webpack_public_path__ + "static/media/linkedin.904770d6.svg";